import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import './styles/globals.css'

const rootEl = document.getElementById('root')
if (!rootEl) throw new Error('#root não encontrado')

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
